export const CreateOneOnOneAssignmentPdfScreenPath =
  "/one-on-one-assignment-pdfs/new";
export const EditOneOnOneAssignmentPdfScreenPath =
  "/one-on-one-assignment-pdfs/:level/:userGroupId/:oneOnOneLessonType/:assignmentNumber/:businessEnglishObjective?";

export function buildEditOneOnOneAssignmentPdfPath(
  level: string,
  userGroupId: string,
  oneOnOneLessonType: string,
  assignmentNumber: number,
  businessEnglishObjective?: string,
): string {
  const base = `/one-on-one-assignment-pdfs/${encodeURIComponent(level)}/${encodeURIComponent(userGroupId)}/${encodeURIComponent(oneOnOneLessonType)}/${assignmentNumber}`;
  return businessEnglishObjective
    ? `${base}/${encodeURIComponent(businessEnglishObjective)}`
    : base;
}
